<template>
  <v-layout class="placeholder" column align-center>
    <loading-block
      class="placeholder__image"
      color="light-grey"
      width="100px"
      height="100px"
    />
    <loading-block
      color="light-grey"
      width="600px"
      height="32x"
    />
  </v-layout>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

import LoadingBlock from '@/shared/components/LoadingBlock/LoadingBlock.vue';

@Component({
  components: {
    LoadingBlock,
  },
})
export default class Placeholder extends Vue {}
</script>

<style lang="scss" scoped>
.placeholder {
  margin-top: 150px;

  &__image  {
    margin-bottom: 24px !important;
  }
}
</style>
